













import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    "date-range-stat": () =>
      import("@/components/app/global/stats/_dateRangeStat.vue")
  }
})
export default class InvoiceAverageValue extends Vue {
  private async calcAverage({ data, defaultValue, currency }) {
    if (!data) {
      const prefix = this.$_.get(currency, "prefix", "");
      const suffix = this.$_.get(currency, "suffix", "");
      return `${prefix} ${defaultValue} ${suffix}`;
    }

    const average =
      this.$_.get(data, "total_amount", 0) / (this.$_.get(data, "count") || 1);

    const calculatedTotal = await this.$store.dispatch("api/calculate", {
      prices: [average],
      currency_id: this.$_.get(data, "currency.id")
    });

    return calculatedTotal.total_formatted;
  }
}
